import React, { useState, useEffect } from "react";
import { Box, TextField, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DocumentItem from "../../../../Components/Masters/DocumentItem";
import { truncateNumber } from "../../../../utils/common";

function ViewTransportation(props) {
  const [edit, setEdit] = useState(false);
  const [valueEdit, setValueEdit] = useState(false);
  const [addEquipment, setAddEquipment] = useState(false);
  useEffect(() => {
    console.log(props.selectedData, props.selectedData?.model, "selectedData");
  }, [props]);

  const handleDownload = (url) => {
    const downloadUrl = url.replace("/upload/", "/upload/fl_attachment/"); // Force download as an attachment
    const link = document.createElement("a");
    link.href = downloadUrl;
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        // maxWidth:"100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => props.setView(false)}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          Rail Transportation Details
        </Typography>
        <Box>
          <Box>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                Date
              </Typography>

              <p>
                {new Date(props.selectedData?.createdAt).toLocaleDateString(
                  "en-GB",
                  { day: "2-digit", month: "2-digit", year: "numeric" }
                ) ?? ""}
                {/* {new Date(props.selectedData?.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' }) ?? ""} */}
              </p>
            </Box>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                Consumption Month
              </Typography>

              <p>
                {`${
                  monthNames[
                    (props.selectedData?.consumptionPeriod.month ?? 1) - 1
                  ]
                } ${props.selectedData?.consumptionPeriod.year ?? ""}`}
              </p>
            </Box>
          </Box>
        </Box>
        <Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Transportation Type
            </Typography>
            <p> {props.selectedData?.transportationType ?? ""}</p>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Source
            </Typography>
            <p> {props.selectedData?.origin ?? ""}</p>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Destination
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
              {props.selectedData?.destination ?? ""}
            </p>
          </Box>
        </Box>
        <Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Freight Load (Tonnes)
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {props.selectedData?.freightLoad.value === ""
                ? "-"
                : truncateNumber(props.selectedData?.freightLoad.value)}
            </p>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Distance Travelled (Km)
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
              {truncateNumber(props.selectedData?.distanceCovered?.value) ?? ""}
            </p>
          </Box>
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          Remark (optional)
        </Typography>
        <p>{props.selectedData?.remark ?? "-"}</p>
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Documents (optional)
          </Typography>

          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            sx={{ width: "100%" }}
          >
            {/* {data && data.documents.length > 0 ? ( */}
            {props.selectedData && props.selectedData.documents.length > 0 ? (
              <>
                {/* Render Images First */}
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {props.selectedData.documents
                    .filter((url) =>
                      ["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`image-${index}`} url={url} />
                    ))}
                </Box>

                {/* Render Other Documents */}
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {props.selectedData.documents
                    .filter(
                      (url) =>
                        !["png", "jpg", "jpeg"].includes(
                          url.split(".").pop().toLowerCase()
                        )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`file-${index}`} url={url} />
                    ))}
                </Box>
              </>
            ) : (
              <Typography variant="body2">-</Typography>
            )}
          </Box>
        </Box>

        {!props?.companyAdmin && (
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={() =>
              props.selectedData?._id !== null &&
              props.handleEdit(props.selectedData)
            }

            // onClick={props.selectedData?._id !== null && props.handleEdit(props.selectedData)}
          >
            Edit
          </Button>
        )}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.view}
        onClose={() => props.setView(false)}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default ViewTransportation;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
